<template lang="pug">
	.creative-personalized-ad
		DxTabPanel(ref="tabs", :dataSource="tabs", :animation-enabled="true", :selectedItem="currentPage", :swipe-enabled="false", :scrollByContent="false")
			template(v-slot:item="{ data }")
				.template
					.flex-col.align-center.center.space-large(v-if="data.id === 'start'")
						img.logo(:src="require('assets/logo_transparent.png')")
						.font-large {{$tCaption('Create your Personalized Synthetic AD')}}
						.personalized-button.clickable.flex-row.align-center.space(:title="$tCaption('Next', '@actions')", @click="gotoPage(1)")
							.text {{$tCaption('Next', '@actions')}}
							.icon-holder.flex-row.align-center.center
								fas(icon="arrow-right")
					.flex-col.space-extralarge.templates-tab(v-if="data.id === 'template'")
						Loader(v-if="isTemplatesLoading", :fullscreen="true", text="")
						.flex-col.space-large
							.flex-row.align-center.center
								img.logo(:src="require('assets/logo_transparent.png')")
							.flex-col.space-medium
								.flex-row.align-center.templates
									.nav-button.left
										DxButton(icon="fas fa-chevron-left", v-if="filteredTemplates.length > take && skip > 0", @click="doSkip(-1)", :activeStateEnabled="false", :focusStateEnabled="false")
									.flex-1.flex-row.space-medium
										.template-item.flex-col.full-width.space.align-center.center.clickable(v-for="template in visibleTemplates", :class="{ selected: selectedTemplate === template, 'has-image': template.ImageUrl }", 
											:style="{ '--image-url': `url('${template.ImageUrl}')` }", @click="selectedTemplate = template")
											.text.flex-row.align-center.center {{removeFilterInName(template.RootCreativeName || template.Name)}}
											Loader(v-if="template.__templateLoadingStatus === 1", :fullscreen="true", text="")
											.img
									.nav-button.right
										DxButton(icon="fas fa-chevron-right", v-if="filteredTemplates.length > take && (skip + take < filteredTemplates.length)", @click="doSkip(1)", :activeStateEnabled="false", :focusStateEnabled="false")
							CreativeTemplatesNewCreative(v-if="templateFields", :templateFields="templateFields", :hideCreativeName="true")
							.flex-col(v-if="selectedTemplate && selectedTemplate.__templateLoadingStatus === 2")
								.font-small.upper.grey {{$tCaption('Email')}}
								DxTextBox(:value.sync="contactEmail", stylingMode="filled", valueChangeEvent="input")
						.flex-row.full-width.justify
							.flex-row
								.personalized-button.grey.clickable.flex-row.align-center.space(:title="$tCaption('Back', '@actions')", @click="gotoPage(-1)")
									.icon-holder.flex-row.align-center.center
										fas(icon="arrow-left")
									.text {{$tCaption('Back', '@actions')}}
							.flex-row
								.personalized-button.clickable.flex-row.align-center.space(:title="$tCaption('Next', '@actions')", @click="gotoPage(1)", :class="{ 'disabled-controls': nextDisabled() }")
									.text {{$tCaption('Next', '@actions')}}
									.icon-holder.flex-row.align-center.center
										fas(icon="arrow-right")
					.flex-col.align-center.center.space-large(v-if="data.id === 'finish'")
						img.logo(:src="require('assets/logo_transparent.png')")
						.flex-row.space.align-center(v-if="isProcessingTemplate")
							fas(icon="spinner" :spin="true" size="xl")
							.font-big {{$tCaption('Processing')}}
						.flex-col.space-large.align-center(v-else)
							.font-big {{$tCaption('Thank you. You will receive a link with your personalized ad in a couple of minutes.')}}
							.personalized-button.clickable.flex-row.align-center.space(:title="$tCaption('Next', '@actions')", @click="resetTemplateFields(); gotoPage(-3)")
								.text {{$tCaption('Again')}}
								.icon-holder.flex-row.align-center.center
									fas(icon="refresh")
</template>

<script>
	import _ from 'lodash';
	import Loader from 'app-core/Loader.vue';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxButton from 'devextreme-vue/button';
	import DxTabPanel from 'devextreme-vue/tab-panel';
	import config from 'app-core/config';
	import CreativeTemplatesNewCreative from 'view/creative/CreativeTemplatesNewCreative.vue';

	export default {
		translationCategory: 'creative.PersonalizedAd',
		name: 'creative-personalized-ad',
		components: {
			Loader, DxTextBox, DxButton, DxTabPanel, CreativeTemplatesNewCreative
		},
		data() {
			const tabs = [{ id: 'start' }, { id: 'template' }, { id: 'finish' }];
			return {
				tabs,
				currentPage: tabs[0],
				templates: [],
				skip: 0,
				take: 3,
				selectedTemplate: null,
				contactEmail: null,
				isProcessingTemplate: false,
				isTemplatesLoading: false
			};
		},
		computed: {
			visibleTemplates() {
				return this.filteredTemplates.slice(this.skip, this.skip + this.take);
			},
			templateFields() {
				return this.selectedTemplate?.JsonConfig?.templateFields;
			},
			filteredTemplates() {
				return this.templates.filter(f => !this.filter || `${f.Name}`.toLowerCase().indexOf(this.filter.toLowerCase()) > -1);
			},
			filter() {
				return this.$route?.query?.filter || '';
			}
		},
		watch: {
			visibleTemplates() {
				this.loadVisibleTemplatesJson();
			}
		},
		mounted() {
			if (__DEBUG__)
				window.personalizedAd = this;
			this.loadTemplates();
			config.setPreventNotifications(true);
		},
		destroyed() {
			config.setPreventNotifications(false);
		},
		methods: {
			removeFilterInName(name) {
				var result = !this.filter ? name : (`${name}`.toLowerCase().endsWith(this.filter.toLowerCase()) ? `${name}`.replace(new RegExp(this.filter, 'gi'), '').trim() : name);
				return result || name;
			},
			nextDisabled() {
				return this.currentPage.id === 'template' && (!this.selectedTemplate || !this.contactEmail || this.templateFields.some(f => !(!f.isComplex && f.default || f.services)));
			},
			loadVisibleTemplatesJson() {
				this.visibleTemplates.filter(f => !f.__templateLoadingStatus).map(f => {
					this.$set(f, '__templateLoadingStatus', 1);
					this.$Data.getExternalApi('Creative/GetCreativeJson', `creativeId=${f.Oid}`).then(r => {
						this.$set(f, 'JsonConfig', _.cloneDeep(r));
						this.$set(f, 'DefaultJsonConfig', _.cloneDeep(r));
					}).finally(() => f.__templateLoadingStatus = 2);
				});
			},
			doSkip(direction) {
				this.skip += direction * this.take;
			},
			gotoPage(direction) {
				this.currentPage = this.tabs[Math.min(this.tabs.length-1, Math.max(0, this.tabs.findIndex(f => f.id === this.currentPage?.id) + direction))];
				if (this.currentPage.id === 'finish') {
					this.initCreative();
				}
			},
			resetTemplateFields() {
				this.selectedTemplate = null;
				this.contactEmail = null;
				this.filteredTemplates.filter(f => f.JsonConfig).map(f => {
					f.JsonConfig = _.cloneDeep(f.DefaultJsonConfig);
				})
			},
			loadTemplates() {
				this.isTemplatesLoading++;
				this.$Data.getExternalApi('Creative/GetCreativeTemplates',`selectOnlyMyTemplates=true`, 99).then(r => {
					this.templates = r.Results;
					this.loadVisibleTemplatesJson();
				}).finally(() => this.isTemplatesLoading--);
			},
			initCreative() {
				this.isProcessingTemplate = true;
				return this.$Data
					.postExternalApi('Creative/CreateCreativeFromTemplate', {
						TemplateId: this.selectedTemplate.Oid,
						CreativeName: `${this.selectedTemplate.RootCreativeName} (${this.contactEmail})`,
						TemplateFields: this.templateFields.map(f => this.$Data.formatObjectToUpperCase(f)),
						PublishImmediate: true,
						EmailAfterPublish: this.contactEmail,
						EmailTemplateCode: 'CREATIVE_VARIANT_HAS_BEEN_PUBLISHED_SHOW_PROMOTION'
					})
					.then((r) => {
						if (__DEBUG__)
							console.debug('CreateCreativeFromTemplate', { r });
					})
					.finally(() => {
						this.isProcessingTemplate = false;
					});
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.creative-personalized-ad {
		.font-large {
			font-size: 3em !important;
		}

		.font-big {
			font-size: 2em !important;
		}

		.font-small {
			font-size: 1em !important;
		}
	
		.logo {
			max-height: 20em;
		}

		.personalized-button {
			font-size: 2em;
			font-weight: 100;
			position: relative;
			border: 2px solid $base-accent;
			border-radius: 6px;
			padding: 2px 12px;
			color: #fff;
			box-shadow: 0px 1px 8px $base-accent;
			background: $base-accent;
			transition: 0.3s;
			
			.icon-holder {
				font-size: 14px;
			}

			.text {
			}

			&.grey {
				background: #e7e7e7;
				color: #717171;
				border: 2px solid #e7e7e7;
				box-shadow: 0px 1px 8px #d3d3d3;
			}

			&:hover {
				background: #ff5213;
				border: 2px solid #ff5213;
				box-shadow: 0px 1px 18px #ff5213;
				color: #fff;
			}
		}

		.dx-tabpanel-tabs {
			display: none !important;
		}

		.dx-item-content {
			padding: 20px 80px !important;
		}

		.templates-tab {
			min-width: 690px;
		}

		.template-item {
			padding: 20px;
			height: 120px;
			background: #ebebeb;
			position: relative;
			border-radius: 6px;
			padding: 2px 12px;
			box-shadow: 0px 1px 8px #ccc;
			transition: 0.3s;
			transform: scale(1);
			user-select: none;
			font-size: 18px;
			font-weight: 100;
			text-align: center;
			position: relative;

			.img {
				position: absolute;
				left: 0px;
				top: 0px;
				width: 100%;
				height: 100%;
				background: var(--image-url);
				background-size: cover;
				background-position: center;
				z-index: -1;
				border-radius: 6px;
				border: 2px solid #e8e8e8;
				transition: 0.3s;
			}

			&.has-image .text {
				position: absolute;
				width: 100%;
				background: rgba(255,255,255,0.85);
				padding: 4px;
				bottom: -6px;
				border-radius: 0px 0px 8px 8px;
			}

			&:hover {
				box-shadow: 0px 1px 18px $base-accent;
				transform: scale(1.02);
			}

			&.selected {
				background: $base-accent;
				box-shadow: 0px 1px 18px $base-accent;
				&:not(.has-image) {
					color: $base-bg;
				}

				&.has-image .text {
					background: $base-accent;
					color: $base-bg;
					padding: 4px;
					bottom: -6px;
					border-radius: 0px 0px 8px 8px;
				}

				.img {
					border: 2px solid $base-accent;
				}
			}

			&:not(.selected) {
				.img {
					filter: saturate(0.4) contrast(0.5) brightness(1.8);
				}
			}
		}

		.nav-button {
			width: 40px;
		}

		.templates {
			//margin-left: -50px;
			position: relative;
		}

		.nav-button {
			position: absolute;
			width: 0px;

			&.left {
				left: -60px;
			}

			&.right {
				right: -20px;
			}
		}
	}
</style>
